import { render, staticRenderFns } from "./SpecificProductRulesForm.vue?vue&type=template&id=38faf84a&scoped=true"
import script from "./SpecificProductRulesForm.vue?vue&type=script&lang=js"
export * from "./SpecificProductRulesForm.vue?vue&type=script&lang=js"
import style0 from "./SpecificProductRulesForm.vue?vue&type=style&index=0&id=38faf84a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38faf84a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38faf84a')) {
      api.createRecord('38faf84a', component.options)
    } else {
      api.reload('38faf84a', component.options)
    }
    module.hot.accept("./SpecificProductRulesForm.vue?vue&type=template&id=38faf84a&scoped=true", function () {
      api.rerender('38faf84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/monitoringConfig/specificProductRules/SpecificProductRulesForm.vue"
export default component.exports